import { Box, Paper, Typography } from '@mui/material';
import { HMIField, HMILiveValues } from '../types';
import FieldRow from './FieldRow';

export interface GroupCardProps {
  title: string;
  fields: HMIField[];
  /** Every field in the template - threaded through to `kind: "image"` fields, whose pins can reference fields in any section. */
  allFields: HMIField[];
  values: HMILiveValues;
  disabledFieldIds: Set<string>;
  onCommit: (field: HMIField, value: unknown) => Promise<{ ok: boolean; error?: string }>;
  onRunAction: (field: HMIField) => Promise<{ ok: boolean; error?: string }>;
}

/** A titled card holding every field that belongs to one `group`. */
function GroupCard({
  title,
  fields,
  allFields,
  values,
  disabledFieldIds,
  onCommit,
  onRunAction,
}: GroupCardProps) {
  if (fields.length === 0) return null;

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }} color="text.secondary">
        {title}
      </Typography>
      <Box>
        {[...fields]
          .sort((a, b) => a.order - b.order)
          .map((field) => (
            <FieldRow
              key={field.id}
              field={field}
              value={values[field.id]}
              compareValue={field.compareFieldId ? values[field.compareFieldId] : undefined}
              allFields={allFields}
              liveValues={values}
              disabled={disabledFieldIds.has(field.id)}
              onCommit={(value) => onCommit(field, value)}
              onRunAction={() => onRunAction(field)}
            />
          ))}
      </Box>
    </Paper>
  );
}

export default GroupCard;
